import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import FontFa from "../../../components/fontFa/fontFa";
import { getFileExt, getReadableFileSizeString } from "../../../services/util";

const UploadFileDragDrop = (props: any) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const [uploadFiles, setFiles] = useState<File[]>([]);

  const DocumentTypeIcon = (props: any) => {
    const { type } = props;
    const getIcon = () => {
      switch (type) {
        case "doc":
        case "docx":
          return <FontFa name="faFileWord" size="lg" color={"#0F4C81"} />;
        case "pptx":
        case "ppt":
          return <FontFa name="faFilePowerpoint" size="lg" color={"#D04423"} />;
        case "xlsx":
          return <FontFa name="faFileExcel" size="lg" color={"#1d6f42"} />;
        case "pdf":
          return <FontFa name="faFilePdf" size="lg" color={"#B0171F"} />;
        default:
          return <FontFa name="faFile" size="lg" />;
      }
    };
    return (
      <div className="d-flex align-items-center">
        <span className="document-type px-2">{getIcon()}</span>
      </div>
    );
  };

  const onDeleteFile = (file: any) => {
    const arr = uploadFiles.filter((f: any) => f.name !== file.name);
    setFiles(arr);
  };

  const getValidText = (file: any) => {
    // if (props.validFile) return props.validFile(file);
    return "";
  };

  useEffect(() => {
    const arr = uploadFiles.concat(acceptedFiles);
    if (arr.length > 0) {
      setFiles(arr);
      props.onCompleted(arr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptedFiles]);

  const files = uploadFiles.map((file: any) => {
    return (
      <div className="file-item mb-3 py-2 d-flex align-items-center">
        <div className="type-icon px-2">
          <DocumentTypeIcon type={getFileExt(file.name)} />
        </div>
        <div className="file-info">
          <div className="file-info__name">{file.name}</div>
          <div className="file-info__size">{getReadableFileSizeString(file.size)}</div>
          <div className="file-error">
            <span>{getValidText(file)}</span>
          </div>
        </div>
        <div
          className="action"
          onClick={() => {
            onDeleteFile(file);
          }}
        >
          <span className="px-3">
            <FontFa name="faTrash" color={"red"} />
          </span>
        </div>
      </div>
    );
  });

  return (
    <div className="container">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <p className="text-center mb-1">
          <FontFa name="faCloudUploadAlt" size="3x" />
        </p>
        <p className="mb-0">Kéo và thả tập tin ở đây</p>
      </div>
      <div className="py-4">{files}</div>
    </div>
  );
};

export default UploadFileDragDrop;
